import { lazy } from "react";
import type { RouteObject } from "react-router";
import { EMAIL_ROUTES } from "@/src/email/constants/email-routes";

const UnsubscribePage = lazy(() => import("../pages/unsubscribe-page"));

export const emailRoutes: RouteObject = {
	path: EMAIL_ROUTES.UNSUBSCRIBE,
	element: <UnsubscribePage />,
};
